// extracted by mini-css-extract-plugin
export var bold = "_ym-0";